import { Injectable } from '@angular/core';
import { CheckBoxState } from '@progress/kendo-angular-inputs';
import { FilterState } from '@unity/utils/filter-state';
import { snakeToCamel } from '@unity/utils/string-transform';
import { ConditionalOperator, GridifyQueryBuilder } from 'gridify-client';

export interface SwitchStateEvent<T> {
  item: keyof T;
  state: boolean;
}

export interface FilterMasterStateEvent<T> {
  key: keyof T;
  state: CheckBoxState;
}

export interface FilterItemToggleEvent<T> {
  key: keyof T;
  item: string;
}

@Injectable({
  providedIn: 'root',
})
export class GridifyService<T> {
  public buildSwitchesQuery(builder: GridifyQueryBuilder, switchSnapshot: Record<keyof T, boolean>) {
    const allSwitches: [string, boolean][] = Object.entries(switchSnapshot);
    if (allSwitches.length === 0) {
      return builder;
    }

    allSwitches.forEach(([switchKey, switchState], i) => {
      const key = snakeToCamel(switchKey);
      builder.addCondition(key, ConditionalOperator.Equal, switchState);
      if (i !== allSwitches.length - 1) {
        builder.and();
      }
    });
    return builder;
  }

  public buildFilterQuery(builder: GridifyQueryBuilder, filters: FilterState<T>[], isAppend: boolean) {
    if (filters.length > 0 && isAppend) {
      builder = builder.and();
    }
    filters.forEach((pFilter, i) => {
      builder.startGroup();

      // Include
      const includes = pFilter.getItemsInState(true);
      if (includes.length > 0) {
        builder.startGroup();
        includes.forEach((item, j) => {
          builder = builder.addCondition(pFilter.key as string, ConditionalOperator.Equal, item);
          if (j !== includes.length - 1) {
            builder = builder.or();
          }
        });
        builder.endGroup();
      }

      // Exclude
      const excludes = pFilter.getItemsInState(false);
      if (excludes.length > 0) {
        // Bridge groups if we had an include group
        if (includes.length > 0) {
          builder = builder.and();
        }
        builder.startGroup();
        excludes.forEach((item, j) => {
          builder = builder.addCondition(pFilter.key as string, ConditionalOperator.NotEqual, item);
          if (j !== excludes.length - 1) {
            builder = builder.and();
          }
        });
        builder.endGroup();
      }
      builder.endGroup();
      if (i !== filters.length - 1) {
        builder = builder.and();
      }
    });
    return builder;
  }
}
